import styled from "@emotion/styled";
import { FloatingLabel as RBFloatingLabel } from "react-bootstrap";

const sizeConfig = {
  sm: {
    fontSize: '0.875rem',
    paddingY: '0.55rem',
    paddingX: '0.75rem',
    height: '38px',
  },
  lg: {
    fontSize: '1rem',
    paddingY: '0.75rem',
    paddingX: '0.75rem',
    height: '48px',
  },
}

const labelTransforms = {
  sm: 'scale(.85) translateY(-.3rem) translateX(1rem)',
  lg: 'scale(.85) translateY(-.5rem) translateX(.15rem)',
}

export const FloatingLabel = styled(RBFloatingLabel, {
  shouldForwardProp: (prop) => prop !== "size",
})`
  width: 100%;
  display: block;
  --bs-form-floating-height: ${({ size = "lg" }) => sizeConfig[size].height};
  --bs-form-floating-input-padding-y: ${({ size = "lg" }) =>
    sizeConfig[size].paddingY};
  --bs-form-floating-input-padding-x: ${({ size = "lg" }) =>
    sizeConfig[size].paddingX};
  --bs-form-floating-label-transform: ${({ size = "lg" }) =>
    labelTransforms[size]};

  & > .form-select {
    min-height: ${({ size = "lg" }) => sizeConfig[size].height};
    font-size: ${({ size = "lg" }) => sizeConfig[size].fontSize};
    box-sizing: border-box;
    height: ${({ size = "lg" }) => sizeConfig[size].height} !important;
    padding: 0.95rem 0 0 0.75rem !important;
  }
  .form-select.is-invalid {
    // background-image: none;
    // padding: 0.95rem 0.75rem 0 0.75rem !important;
  }

  .form-control {
    height: ${({ size = "lg" }) => sizeConfig[size].height};
    min-height: ${({ size = "lg" }) => sizeConfig[size].height};
  }

  .form-control.is-invalid {
    background-image: none;
    padding: 0.95rem 0.75rem 0 0.75rem !important;
  }

  & > label {
    padding: var(--bs-form-floating-input-padding-y)
      var(--bs-form-floating-input-padding-x);
  }
`;
